import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { mapState, mapActions } from "vuex";
import { UPDATE_UPCOMING_ACTIVITY, CLEAR_COMPLETE_ACTIVITIES, CLEAR_READ_STATUS } from "../../../store/activity-center-actions";
import UpcomingActivity from "./upcoming-activities/upcoming-activity";
import EmptyMessage from "./empty-message";
import ActivityLoader from "./activity-loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UpcomingActivitiesContainer",
  components: {
    UpcomingActivity,
    EmptyMessage,
    ActivityLoader
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filteredFollowups: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ActivityCenterStore", {
    followUps(state) {
      return state.followUps.byId;
    }
  })), {}, {
    noActivities() {
      return _Object$keys(this.followUps).length === 0;
    },
    sortedFollowUps() {
      var _context;
      return _sortInstanceProperty(_context = _Object$values(this.followUps)).call(_context, (a, b) => {
        const momentA = moment(`${a.scheduledDate} ${a.scheduledTime}`, "YYYY-MM-DD HH:mm:ss");
        const momentB = moment(`${b.scheduledDate} ${b.scheduledTime}`, "YYYY-MM-DD HH:mm:ss");
        return momentA.unix() - momentB.unix();
      });
    },
    hasCompletedFollowups() {
      return this.sortedFollowUps.some(({
        complete
      }) => complete);
    }
  }),
  beforeDestroy() {
    this.clearCompleteActivities().then(() => {
      this.CLEAR_READ_STATUS({
        type: "followUps"
      });
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ActivityCenterStore", [UPDATE_UPCOMING_ACTIVITY, CLEAR_COMPLETE_ACTIVITIES, CLEAR_READ_STATUS])), {}, {
    handleActivityChange({
      complete,
      id
    }) {
      this.UPDATE_UPCOMING_ACTIVITY({
        complete,
        id
      });
    },
    async clearCompleteActivities() {
      return this.CLEAR_COMPLETE_ACTIVITIES();
    }
  })
});